module.exports = __webpack_public_path__ + "static/media/4.d80c0b14.jpg";